// test957
(957 && 0);
